import Vue from 'vue';
import {Uploader, Loading, Toast, Field, Button} from 'vant';

Vue.use(Uploader);
Vue.use(Loading);
Vue.use(Toast);
Vue.use(Field);
Vue.use(Button);

export default {
};



// WEBPACK FOOTER //
// ./src/config/vant.js